import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ReferralContext = createContext(null);
const KEY = "je_ref_v1";

export const ReferralProvider = ({ children }) => {
  const [code, setCode] = useState(() => localStorage.getItem(KEY) || "");
  const [ambassador, setAmbassador] = useState(null); // { code, name, discount_percent } | null

  // On mount and on URL change: detect ?ref=... from window.location
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      const clean = ref.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 24);
      if (clean && clean !== code) {
        setCode(clean);
        localStorage.setItem(KEY, clean);
      }
      // fire-and-forget visit tracking
      api.post("/ambassadors/visit", { code: clean }).catch(() => {});
    }
    // eslint-disable-next-line
  }, []);

  // Lookup ambassador info whenever the code changes
  useEffect(() => {
    if (!code) { setAmbassador(null); return; }
    let cancelled = false;
    api
      .get("/ambassadors/lookup", { params: { code } })
      .then(({ data }) => { if (!cancelled) setAmbassador(data); })
      .catch(() => { if (!cancelled) setAmbassador(null); });
    return () => { cancelled = true; };
  }, [code]);

  const clearReferral = useCallback(() => {
    setCode("");
    setAmbassador(null);
    localStorage.removeItem(KEY);
  }, []);

  return (
    <ReferralContext.Provider value={{ code, ambassador, clearReferral }}>
      {children}
    </ReferralContext.Provider>
  );
};

export const useReferral = () => useContext(ReferralContext);
